export const toSnakeCase = (key: string): string => {
  return key
    .toLowerCase()
    .replace(/[()]/g, '')
    .replace(/[-\s.]+/g, ' ')
    .trim()
    .replace(/\s+/g, '_');
};
